const CN_ORIGIN = 'https://www.fgqslc.com'
const EN_ORIGIN = 'https://en.fgqslc.com'

const STABLE_PAIRED_ROUTES = new Set([
  'index',
  'types',
  'afterSale',
  'guide',
  'news',
  'aboutUs',
  'contactUs'
])

const DEFAULT_SEO = {
  title: '富贵泉电动三轮车官网｜电动三轮车厂家',
  description: '富贵泉专注电动三轮车及零部件研发、生产、销售与服务，提供货运、载人、环卫等系列车型，欢迎了解产品与服务。'
}

const ROUTE_SEO = {
  index: DEFAULT_SEO,
  types: {
    title: '电动三轮车产品系列｜货运·载人·环卫车型｜富贵泉',
    description: '查看富贵泉电动三轮车产品系列，包括货运、载人、带篷、环卫及其他应用车型，按使用需求了解产品。'
  },
  show: {
    title: '电动三轮车产品详情｜富贵泉',
    description: '了解富贵泉电动三轮车产品图片、车型特点与相关产品信息。'
  },
  afterSale: {
    title: '电动三轮车售后服务｜富贵泉服务支持',
    description: '了解富贵泉电动三轮车服务渠道、服务响应与售后支持信息。'
  },
  guide: {
    title: '电动三轮车使用与保养指南｜富贵泉',
    description: '查看富贵泉电动三轮车车辆保养、维修及零部件质保相关使用指南。'
  },
  news: {
    title: '富贵泉新闻动态｜电动三轮车企业资讯',
    description: '了解富贵泉电动三轮车产品、企业与服务相关的最新资讯。'
  },
  newdetail: {
    title: '新闻详情｜富贵泉电动三轮车',
    description: '阅读富贵泉电动三轮车企业与产品相关资讯。',
    type: 'article'
  },
  aboutUs: {
    title: '关于富贵泉｜电动三轮车研发与制造企业',
    description: '了解富贵泉的企业愿景、产品研发、生产销售与服务理念。'
  },
  contactUs: {
    title: '联系富贵泉｜电动三轮车产品与服务咨询',
    description: '联系富贵泉了解电动三轮车产品、业务合作与服务支持信息。'
  },
  feadback: {
    title: '用户反馈｜富贵泉',
    description: '向富贵泉提交产品与服务使用反馈。',
    robots: 'noindex,nofollow'
  },
  jobIndex: { title: '人才招聘｜富贵泉', description: '了解富贵泉人才招聘信息。' },
  jobList: { title: '招聘职位｜富贵泉', description: '查看富贵泉当前招聘职位。' },
  jobInfo: { title: '职位详情｜富贵泉', description: '查看富贵泉招聘职位详情。' },
  getjob: { title: '投递简历｜富贵泉', description: '向富贵泉提交职位申请。', robots: 'noindex,nofollow' },
  notfound: {
    title: '页面未找到｜富贵泉',
    description: '您访问的页面不存在，请返回富贵泉官网首页。',
    robots: 'noindex,nofollow'
  }
}

const BREADCRUMB_NAMES = {
  types: '产品中心',
  show: '产品详情',
  afterSale: '售后服务',
  guide: '使用指南',
  news: '新闻动态',
  newdetail: '新闻详情',
  aboutUs: '关于我们',
  contactUs: '联系我们'
}

function normalizedPath(route) {
  if (!route || route.path === '/index') return '/'
  const path = route.path || '/'
  const allowedQuery = route.name === 'show'
    ? ['id', 'op']
    : route.name === 'newdetail' || route.name === 'jobInfo'
      ? ['id']
      : []
  const query = allowedQuery
    .filter(key => route.query && route.query[key] !== undefined)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(route.query[key])}`)
    .join('&')
  return query ? `${path}?${query}` : path
}

function setMeta(selector, attributes) {
  let element = document.head.querySelector(selector)
  if (!element) {
    element = document.createElement('meta')
    element.setAttribute('data-seo', 'true')
    document.head.appendChild(element)
  }
  Object.keys(attributes).forEach(key => element.setAttribute(key, attributes[key]))
}

function setLink(selector, attributes) {
  let element = document.head.querySelector(selector)
  if (!element) {
    element = document.createElement('link')
    element.setAttribute('data-seo', 'true')
    document.head.appendChild(element)
  }
  Object.keys(attributes).forEach(key => element.setAttribute(key, attributes[key]))
}

function removeAlternateLinks() {
  document.head
    .querySelectorAll('link[rel="alternate"][hreflang]')
    .forEach(element => element.remove())
}

function setJsonLd(id, data) {
  let element = document.getElementById(id)
  if (!element) {
    element = document.createElement('script')
    element.type = 'application/ld+json'
    element.id = id
    element.setAttribute('data-seo', 'true')
    document.head.appendChild(element)
  }
  element.textContent = JSON.stringify(data)
}

function removeJsonLd(id) {
  const element = document.getElementById(id)
  if (element) element.remove()
}

export function applyRouteSeo(route, overrides = {}) {
  const base = ROUTE_SEO[route && route.name] || DEFAULT_SEO
  const seo = Object.assign({}, DEFAULT_SEO, base, overrides)
  const path = normalizedPath(route)
  const canonical = `${CN_ORIGIN}${path}`

  document.documentElement.lang = 'zh-CN'
  document.title = seo.title
  setMeta('meta[name="description"]', { name: 'description', content: seo.description })
  setMeta('meta[name="robots"]', { name: 'robots', content: seo.robots || 'index,follow,max-image-preview:large' })
  setMeta('meta[property="og:locale"]', { property: 'og:locale', content: 'zh_CN' })
  setMeta('meta[property="og:type"]', { property: 'og:type', content: seo.type || 'website' })
  setMeta('meta[property="og:site_name"]', { property: 'og:site_name', content: '富贵泉' })
  setMeta('meta[property="og:title"]', { property: 'og:title', content: seo.title })
  setMeta('meta[property="og:description"]', { property: 'og:description', content: seo.description })
  setMeta('meta[property="og:url"]', { property: 'og:url', content: canonical })
  setLink('link[rel="canonical"]', { rel: 'canonical', href: canonical })

  if (route && STABLE_PAIRED_ROUTES.has(route.name)) {
    const alternate = `${EN_ORIGIN}${path}`
    setLink('link[rel="alternate"][hreflang="zh-CN"]', { rel: 'alternate', hreflang: 'zh-CN', href: canonical })
    setLink('link[rel="alternate"][hreflang="en"]', { rel: 'alternate', hreflang: 'en', href: alternate })
    setLink('link[rel="alternate"][hreflang="x-default"]', { rel: 'alternate', hreflang: 'x-default', href: alternate })
  } else {
    removeAlternateLinks()
  }

  if (route && route.name === 'index') {
    setJsonLd('organization-jsonld', {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '四川省广汉市富贵车业有限公司',
      alternateName: '富贵泉',
      url: CN_ORIGIN,
      logo: `${CN_ORIGIN}/favicon.ico`,
      address: {
        '@type': 'PostalAddress',
        streetAddress: '汉州街道汉州工业园区',
        addressLocality: '广汉市',
        addressRegion: '四川省',
        addressCountry: 'CN'
      }
    })
    setJsonLd('website-jsonld', {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '富贵泉电动三轮车官网',
      alternateName: '富贵泉',
      url: CN_ORIGIN,
      inLanguage: 'zh-CN',
      publisher: {
        '@type': 'Organization',
        name: '四川省广汉市富贵车业有限公司'
      }
    })
  } else {
    removeJsonLd('organization-jsonld')
    removeJsonLd('website-jsonld')
  }

  if (!route || route.name !== 'types') {
    removeJsonLd('product-list-jsonld')
  }

  if (route && BREADCRUMB_NAMES[route.name]) {
    setJsonLd('breadcrumb-jsonld', {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首页', item: `${CN_ORIGIN}/` },
        { '@type': 'ListItem', position: 2, name: BREADCRUMB_NAMES[route.name], item: canonical }
      ]
    })
  } else {
    removeJsonLd('breadcrumb-jsonld')
  }
}

export function setPageJsonLd(id, data) {
  setJsonLd(id, data)
}

export function removePageJsonLd(id) {
  removeJsonLd(id)
}
